export default "__VITE_ASSET__4d09167a__"